export default __webpack_public_path__ + "static/media/fin.f80b66aa.png";